module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPaperVisible) ? _c('div', {
    staticStyle: {
      "padding-bottom": "200px"
    }
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("Visualizando os dados da Submissão #" + _vm._s(_vm.paper.id))]), _vm._v(" "), _c('el-row', {
    staticClass: "registration-data submission-data",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('table', {
    staticClass: "table-confirmation"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dados da Submissão")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Tipo de Trabalho:")]), _vm._v(" " + _vm._s(_vm.paper.event_paper_type.paper_type.name) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v("Submetido por:")]), _vm._v(" " + _vm._s(_vm.paper.registration.person.pessoa.nome) + "\n                            (" + _vm._s(_vm.paper.registration.person.ref_pessoa) + ")\n                        ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Data da Submissão:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(_vm.paper.date_submitted)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.paper.status.name))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Data da últ. atualização:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(_vm.paper.last_modified)) + "\n                        ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-confirmation",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dados do Trabalho")])])]), _vm._v(" "), _c('tbody', [(_vm.paper.knowledge_area) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Área do Conhecimento:")]), _vm._v(" " + _vm._s(_vm.paper.knowledge_area.full_name) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paper.contents), function(content) {
    return _c('tr', [(content.event_paper_type_field.field.type !== 'file') ? _c('td', {
      staticClass: "dont-break-out"
    }, [_c('strong', [_vm._v(_vm._s(content.event_paper_type_field.field.name) + ":")]), _vm._v(" " + _vm._s(content.value) + "\n                    ")]) : _vm._e(), _vm._v(" "), (content.event_paper_type_field.field.type === 'file') ? _c('td', {
      staticClass: "dont-break-out",
      class: {
        '-missing-file': content.value === ''
      }
    }, [(content.value && content.value !== '') ? _c('span', [_c('strong', [_vm._v(_vm._s(content.event_paper_type_field.field.name) + ":")]), _vm._v(" " + _vm._s(content.value) + " "), _c('span', {
      staticClass: "paper-content-file-version"
    }, [_vm._v("(Versão: " + _vm._s(content.version) + ")")])]) : _vm._e()]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('table', {
    staticClass: "table-confirmation"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Autores")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paper.authors), function(author) {
    return _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v(_vm._s(author.author_type.name) + " " + _vm._s(author.seq))]), _vm._v(" "), (author.primary_contact) ? _c('span', [_vm._v(" - Contato Principal")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nome Completo:")]), _vm._v(" " + _vm._s(author.first_name + ' ' + author.last_name) + "\n                        ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(author.email))])])])
  }))]), _vm._v(" "), (_vm.paper) ? _c('paper-show-screening', {
    attrs: {
      "paper": _vm.paper
    }
  }) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('paper-show-evaluation', {
    attrs: {
      "paper": _vm.paper
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showPaperPreview) ? _c('div', [_c('h3', [_vm._v("Preview do Trabalho")]), _vm._v(" "), (_vm.getPaperFilePath) ? _c('object', {
    attrs: {
      "data": _vm.getPaperFilePath,
      "type": "application/pdf"
    }
  }, [_c('embed', {
    attrs: {
      "src": _vm.getPaperFilePath,
      "type": "application/pdf"
    }
  })]) : _c('div', [_vm._v("\n            Arquivo não encontrado\n        ")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f4b1205!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/PaperShow.vue
// module id = 717
// module chunks = 2